<template>
  <v-sheet flat class="pa-10">
    <div class="d-flex">
      <v-select
        solo
        style="max-width: 300px; width: 200px;"
        v-model="season_id"
        :items="unarchived_seasons"
        item-text="season_name"
        item-value="id"
        label="Kausi"
        :loading="loading_seasons"
        @change="changeSeason($event)"
      ></v-select>
      <v-select
        @change="handleTeamChange($event)"
        :value="selected_club_id"
        :items="clubs"
        :loading="loading_clubs"
        item-text="club_name"
        item-value="id"
        placeholder="Valitse joukkue"
        clearable
        solo
        class="ml-3"
        style="max-width: 300px;"
      >
        <!-- How the selected item appears in the input -->
        <template #selection="{ item }">
          <div class="d-flex align-center">
            <v-img
              v-if="item && item.small_logo_url"
              :src="item.small_logo_url"
              width="20"
              height="20"
              contain
              class="mr-2"
            />
            <span v-if="item">{{ item.club_name }}</span>
          </div>
        </template>

        <!-- How each item appears in the list dropdown -->
        <template #item="{ item, attrs, on }">
          <!-- Important: pass v-bind="attrs" and v-on="on" so Vuetify can handle clicks -->
          <v-list-item
            v-if="item"
            v-bind="attrs"
            v-on="on"
          >
            <v-list-item-avatar>
              <v-img
                :src="item.small_logo_url"
                width="40"
                height="40"
                contain
              />
            </v-list-item-avatar>
            <v-list-item-title>
              {{ item.club_name }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>

    </div>
    <v-alert
      v-if="showFinalsRecordingBanner"
      type="warning"
      prominent
      border="left"
      colored-border
      class="mt-2 mb-6"
    >
      Neljännen finaalin tallenteessa vikaa. Klipit väärässä kohdassa. Asiaa tutkitaan ja peli käsitellään tarvittaessa uudelleen.
    </v-alert>
    <v-sheet
      v-if="loading_games"
      class="d-flex justify-center my-4"
    >
      <Loader></Loader>
    </v-sheet>
    <v-row v-else-if="filteredGames.length && !loading_games" class="pb-16">
      <v-col
        cols="12" lg="4" md="6" sm="12"
        v-for="game in filteredGames"
        :key="game.id + 'game'"
      >
        <user-game-card
          :season="season"
          :game="game"
        ></user-game-card>
      </v-col>
    </v-row>
    <v-card-title v-else>
      Ei pelejä
    </v-card-title>
  </v-sheet>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import UserGameCard from '../components/tiimi_admin/league/game/UserGameCard.vue'
import Loader from '../components/video/Loader.vue';

export default {
  components: { UserGameCard, Loader },
  data: () => ({
    season_id: null,
    selected_club_id: null
  }),
  mounted() {
    this.initSeasons(this.currentTeam.league_id)
    this.initClubs(this.currentTeam.league_id)

    if(this.$route.query.club_id) {
      this.selected_club_id = parseInt(this.$route.query.club_id)
    }

    let q = this.$route.query.season_id
    if(q) {
      this.season_id = parseInt(q)
      this.initGames({season_id: this.season_id})
        .then(e => {
          this.finalizeInit(e.season_id)
        })
    } else {
      this.initGames({})
        .then(e => {
          this.finalizeInit(e.season_id)
        })
    }
  },
  methods: {
    ...mapActions('admin', [
      'initGames',
      'initSeasons',
      'initClubs',
      'getSeasonStates'
    ]),
    handleTeamChange(club_id) {
      this.selected_club_id = club_id
      this.$router.replace({ query: { club_id }})
    },
    finalizeInit(season_id) {
      this.season_id = season_id
      this.getSeasonStates({ id: season_id })
    },
    changeSeason(season_id) {
      this.$router.replace({ query: { season_id }})
      this.initGames({ season_id })
    }
  },
  computed: {
    ...mapGetters('admin', [
      'games',
      'seasons',
      'loading_seasons',
      'loading_games',
      'season_by_id',
      'unarchived_seasons',
      'clubs',
      'loading_clubs'
    ]),
    ...mapGetters('user', [
      'currentTeam',
      'currentLeagueName'
    ]),
    showFinalsRecordingBanner() {
      const hideAfter = Date.parse('2026-09-22T00:00:00+03:00')
      return this.currentLeagueName === 'nsu' && Date.now() < hideAfter
    },
    filteredGames() {
      return this.games.filter(game => {
        if(this.selected_club_id) {
          return game.home_club_id == this.selected_club_id || game.away_club_id == this.selected_club_id
        }
        return true
      });
    },
    season() {
      return this.season_by_id(this.season_id) || {}
    }
  }
}
</script>